<div id="fieldDetalleGeneral">
  <fieldset>
    <legend>{{ translate('Generales') }}</legend>

    <div class="row">
      <div class="row" style="width: 50%;">
        <span style="width: 100%;">
          <div style="margin-top: 5px; clear: both">
            {{ translate("Tiempo_recogida") }}
          </div>
          <jqxInput [value]="elemEdit?.Equipamiento?.TiempoRecogida"
            [width]="'80%'" [disabled]="true" [rtl]="true">
          </jqxInput>
        </span>
      </div>

      <div class="row" style="width: 50%;">
        <span style="width: 100%;">
          <div style="margin-top: 5px; clear: both">
            {{ translate("Tipo_material") }}
          </div>
          <jqxInput [value]="elemEdit?.Equipamiento?.TipoMaterial"
            [width]="'100%'" [disabled]="true" [rtl]="true">
          </jqxInput>
        </span>
      </div>
    </div>

    <div class="row">
      <div class="row" style="width: 50%;">
        <span style="width: 100%;">
          <div style="margin-top: 5px; clear: both">
            {{ translate("Tiene_ruedas_pregunta") }}
          </div>
          <jqxDropDownList (onChange)="elemEdit.Equipamiento !== null ? elemEdit?.Equipamiento.Ruedas = $event : null"
            [width]="'100%'" [dropDownHeight]="60" [source]="sourceRuedas"
            [selectedIndex]="elemEdit?.Equipamiento?.Ruedas" [disabled]="true">
          </jqxDropDownList>
        </span>
      </div>

      <div class="row" style="width: 50%;">
        <span style="width: 100%;">
          <div style="margin-top: 5px; clear: both">
            {{ translate("Tiene_pedal_pregunta") }}
          </div>
          <jqxDropDownList (onChange)="elemEdit.Equipamiento !== null ? elemEdit?.Equipamiento.Pedal = $event : null"
            [width]="'100%'" [dropDownHeight]="60" [source]="sourcePedal"
            [selectedIndex]="elemEdit?.Equipamiento?.Pedal" [disabled]="true">
          </jqxDropDownList>
        </span>
      </div>
    </div>

    <div class="row">
      <div class="row" style="width: 40%;">
        <span style="width: 100%;">
          <div style="margin-top: 5px; clear: both">
            {{ translate("Emplazamiento") }}
          </div>
          <jqxInput [value]="elemEdit?.Equipamiento?.Emplazamiento?.Nombre"
            [width]="'40%'" [disabled]="true" [rtl]="true">
          </jqxInput>
        </span>
      </div>

      <div class="row" style="width: 60%;">
        <span style="width: 100%;">
          <div style="margin-top: 5px; clear: both">
            {{ translate("Area_influencia") }} (m)
          </div>
          <jqxInput [value]="elemEdit?.Equipamiento?.AreaInfluencia"
            [width]="'40%'" [disabled]="true" [rtl]="true">
          </jqxInput>
        </span>
      </div>
    </div>

    <div class="row" style="width: 50%;">
      <span style="width: 100%;">
        <div style="margin-top: 5px; clear: both">
          {{ translate("Numero_fracciones") }}
        </div>
        <div class="row">
          <jqxInput [value]="elemEdit?.Equipamiento?.NumeroFracciones"
            [width]="'40%'" [disabled]="true" [rtl]="true">
          </jqxInput>

          <jqxButton #myButton [width]="80" [height]="25" [textPosition]="'center'"
            [hidden]="elemEdit?.Equipamiento?.NumeroFracciones === 0 || !elemEdit?.Equipamiento?.NumeroFracciones"
            [value]='translate("Fracciones")' [theme]="environment.tema" (onClick)="openFracciones($event)">
          </jqxButton>
        </div>
      </span>
    </div>
  </fieldset>
</div>

<div id="fieldDetallePesosMedidas">
  <fieldset>
    <legend>{{ translate('Pesos_medidas') }}</legend>

    <div class="row">
      <span style="width: 50%;">
        <div style="margin-top: 5px; clear: both">
          {{ translate("Ancho") }} (cm)
        </div>
        <jqxInput [value]="elemEdit?.Equipamiento?.Ancho"
          [width]="'40%'" [disabled]="true" [rtl]="true">
        </jqxInput>
      </span>

      <span style="width: 50%;">
        <div style="margin-top: 5px; clear: both">
          {{ translate("Alto") }} (cm)
        </div>
        <jqxInput [value]="elemEdit?.Equipamiento?.Altura"
          [width]="'40%'" [disabled]="true" [rtl]="true">
        </jqxInput>
      </span>
    </div>

    <div class="row">
      <span style="width: 50%;">
        <div style="margin-top: 5px; clear: both">
          {{ translate("Largo") }} (cm)
        </div>
        <jqxInput [value]="elemEdit?.Equipamiento?.Largo"
          [width]="'40%'" [disabled]="true" [rtl]="true">
        </jqxInput>
      </span>

      <span style="width: 50%;">
        <div style="margin-top: 5px; clear: both">
          {{ translate("Diametro") }} (cm)
        </div>
        <jqxInput [value]="elemEdit?.Equipamiento?.Diametro"
          [width]="'40%'" [disabled]="true" [rtl]="true">
        </jqxInput>
      </span>
    </div>

    <div class="row">
      <span style="width: 50%;">
        <div style="margin-top: 5px; clear: both">
          {{ translate("Ancho_interior") }} (cm)
        </div>
        <jqxInput [value]="elemEdit?.Equipamiento?.AnchoInterior"
          [width]="'40%'" [disabled]="true" [rtl]="true">
        </jqxInput>
      </span>

      <span style="width: 50%;">
        <div style="margin-top: 5px; clear: both">
          {{ translate("Altura_interior") }} (cm)
        </div>
        <jqxInput [value]="elemEdit?.Equipamiento?.AltoInterior"
          [width]="'40%'" [disabled]="true" [rtl]="true">
        </jqxInput>
      </span>
    </div>

    <div class="row">
      <span style="width: 50%;">
        <div style="margin-top: 5px; clear: both">
          {{ translate("Altura_sensor") }} (cm)
        </div>
        <jqxInput [value]="elemEdit?.Equipamiento?.AlturaSensor"
          [width]="'40%'" [disabled]="true" [rtl]="true">
        </jqxInput>
      </span>

      <span style="width: 50%;">
        <div style="margin-top: 5px; clear: both">
          {{ translate("Grados_sensor") }} (º)
        </div>
        <jqxInput [value]="elemEdit?.Equipamiento?.GradosSensor"
          [width]="'40%'" [disabled]="true" [rtl]="true">
        </jqxInput>
      </span>
    </div>

    <div class="row">
      <span style="width: 50%;">
        <div style="margin-top: 5px; clear: both">
          {{ translate("Altura_muerta") }} (cm)
        </div>
        <jqxInput [value]="elemEdit?.Equipamiento?.AlturaMuerta"
          [width]="'40%'" [disabled]="true" [rtl]="true">
        </jqxInput>
      </span>

      <span style="width: 50%;">
        <div style="margin-top: 5px; clear: both">
          {{ translate("Capacidad") }} (L)
        </div>
        <jqxInput [value]="elemEdit?.Equipamiento?.CapacidadLitros"
          [width]="'40%'" [disabled]="true" [rtl]="true">
        </jqxInput>
      </span>
    </div>

    <div class="row">
      <span style="width: 50%;">
        <div style="margin-top: 5px; clear: both">
          {{ translate("Coeficiente_conversion") }}
        </div>
        <jqxInput [value]="elemEdit?.Equipamiento?.CoeficienteConversion"
          [width]="'40%'" [disabled]="true" [rtl]="true">
        </jqxInput>
      </span>

      <span style="width: 50%;">
        <div style="margin-top: 5px; clear: both">
          {{ translate("Capacidad") }} (Kg)
        </div>
        <jqxInput [value]="elemEdit?.Equipamiento?.CapacidadKilos"
          [width]="'40%'" [disabled]="true" [rtl]="true">
        </jqxInput>
      </span>
    </div>

    <div class="row" style="justify-content: start;">
      <span style="width: 50%;">
        <div style="margin-top: 5px; clear: both">
          {{ translate("Carga_maxima") }} (Kg)
        </div>
        <jqxInput [value]="elemEdit?.Equipamiento?.CargaMaximaAutorizada"
          [width]="'40%'" [disabled]="true" [rtl]="true">
        </jqxInput>
      </span>

      <span style="width: 50%;">
        <div style="margin-top: 5px; clear: both">
          {{ translate("Tara") }} (Kg)
        </div>
        <jqxInput [value]="elemEdit?.Equipamiento?.Tara"
          [width]="'40%'" [disabled]="true" [rtl]="true">
        </jqxInput>
      </span>
    </div>
  </fieldset>
</div>

<div id="fieldDetalleInformacionGrafica">
  <fieldset>
    <legend>{{ translate('Informacion_grafica') }}</legend>

    <div class="row" style="justify-content: flex-start !important;">
      <span>
        <div style="margin-top: 5px; clear: both">
          {{ translate("Icono_elemento") }}
        </div>
        <img #imgPrincipal *ngIf="elemEdit?.Equipamiento?.Icono && elemEdit?.Equipamiento?.Icono?.length > 100"
          src="data:image/png;base64,{{elemEdit.Equipamiento?.Icono}}">
      </span>
    </div>

    <div class="row" style="justify-content: flex-start !important;">
      <span>
        <div style="margin-top: 5px; clear: both">
          {{ translate("Icono_punto_ubicacion") }}
        </div>
        <img #imgPrincipal *ngIf="elemEdit?.PU?.Equipamiento?.Icono && elemEdit?.PU?.Equipamiento?.Icono?.length > 100 "
          src="data:image/png;base64,{{elemEdit.Pu?.Equipamiento?.Icono}}">
      </span>
    </div>
  </fieldset>
</div>

<div id="fieldDetalleClasesElemento">
  <fieldset>
    <legend>{{ translate('Clases_asociadas_elemento') }}</legend>

    <jqxGrid #gridClasesAsociadas [theme]="environment.tema" [width]="'100%'" [height]="'calc(100% - 5px)'"
      [appCellClick] [source]="dataAdapterClasesAsociadas" [enablebrowserselection]="true"
      [columns]="columnsClasesAsociadas" [showdefaultloadelement]="false" [localization]="langGrid" [columnsheight]="20"
      [rowsheight]="22">
    </jqxGrid>
  </fieldset>
</div>

<jqxWindow #fracciones id="winFracciones" [width]="200" [height]="220" [zIndex]="101" [isModal]="true"
  [position]="'center'" [showCloseButton]="true" [autoOpen]="false" [theme]="environment.tema" [resizable]="false"
  [title]="translate('Tabla_fracciones')" [position]="{ x: winFracLeft, y: winFracTop }">

  <div class="form" style="float: left; overflow-x: hidden;">
    <div style="float: left; width: 100%; height: 100%;">
      <jqxGrid #gridFracciones [theme]="environment.tema" [height]="'calc(100% - 50px)'" [width]="'100%'"
        [enablebrowserselection]="true" [source]="dataAdapterFracciones" [columnsresize]="true" [appCellClick]
        [columns]="columnsFracciones" [sortable]="true" [altrows]="true" [showrowlines]="false" [rowsheight]="20"
        [columnsheight]="20" [localization]="langGrid">
      </jqxGrid>

      <div style="display: flex; justify-content: center;">
        <jqxButton style="float: left; margin-right: 2px; margin-top: 5px;" [width]="55" [height]="25"
          [textPosition]="'center'" [value]="translate('Cerrar')" (onClick)="clickCerrar()">
        </jqxButton>
      </div>
    </div>
  </div>
</jqxWindow>
